import type { SVGProps } from "react";

export const Pylon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 144 144"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Pylon</title>
    <path d="M0 0h144v144H0z" fill="#4F46E5" />
    <path
      clipRule="evenodd"
      d="M72 122c27.614 0 50-22.386 50-50S99.614 22 72 22 22 44.386 22 72s22.386 50 50 50Zm6.25-13.018c17.736-2.976 31.25-18.4 31.25-36.982 0-18.581-13.514-34.006-31.25-36.981v73.963Zm-12.5 0v-9.899H46.063a37.4 37.4 0 0 0 19.687 9.899Zm0-22.399V78.25H35.019a37.224 37.224 0 0 0 2.422 8.333H65.75Zm0-20.833v-8.333H37.441a37.224 37.224 0 0 0-2.422 8.333H65.75Zm0-20.833v-9.898a37.393 37.393 0 0 0-19.687 9.898H65.75Z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);

export default Pylon;
